import axios from '@/utils/axios'

// GET ALL
export const getTemplates = (params = {}) => {
 return axios.get('/whatsapp-followup-templates', { params })
}

// GET BY ID
export const getTemplateById = (id) => {
 return axios.get(`/whatsapp-followup-templates/${id}`)
}

// GET BY CODE
export const getTemplateByCode = (code) => {
 return axios.get(`/whatsapp-followup-templates/${code}/code`)
}

// CREATE
export const createTemplate = (data) => {
 return axios.post('/whatsapp-followup-templates', data)
}

// UPDATE
export const updateTemplate = (id, data) => {
 return axios.put(`/whatsapp-followup-templates/${id}`, data)
}

// DELETE
export const deleteTemplate = (id) => {
 return axios.delete(`/whatsapp-followup-templates/${id}`)
}